import { Link } from "@tanstack/react-router";
import { formatDate } from "../../lib/format";
import { Button, Card, EmptyState, Loading, PageHeader, StatusBadge, Table, Td } from "../../components/ui";
import { can, useCatalog, useMigrations, useWorkspace, useWorkspaceId } from "./hooks";

export function MigrationsPage() {
  const ws = useWorkspaceId();
  const detail = useWorkspace(ws);
  const migrations = useMigrations(ws);
  const catalog = useCatalog();
  const kitName = new Map((catalog.data?.kits ?? []).map((k) => [k.id, k.name]));
  const canRun = can(detail.data?.permissions, "migrations.run");
  const newBtn = canRun && (
    <Link to="/w/$workspaceId/migrations/new" params={{ workspaceId: ws }}>
      <Button>New migration</Button>
    </Link>
  );
  return (
    <>
      <PageHeader title="Migrations" subtitle="Each migration maps one source to one target. Preview for free, run, and undo if needed." actions={newBtn} />
      <Card>
        {migrations.isLoading ? (
          <Loading />
        ) : migrations.data?.length ? (
          <Table head={["Name", "Kit", "Data", "Status", "Updated"]}>
            {migrations.data.map((m) => (
              <tr key={m.id}>
                <Td>
                  <Link className="text-accent font-medium hover:underline" to="/w/$workspaceId/migrations/$migrationId" params={{ workspaceId: ws, migrationId: m.id }}>
                    {m.name}
                  </Link>
                </Td>
                <Td>{kitName.get(m.kitId) ?? m.kitId}</Td>
                <Td>{m.entity}</Td>
                <Td>
                  <StatusBadge status={m.status} />
                </Td>
                <Td className="muted">{formatDate(m.updatedAt)}</Td>
              </tr>
            ))}
          </Table>
        ) : (
          <EmptyState title="No migrations yet" action={newBtn}>
            Pick a kit, such as Mailchimp → Klaviyo or Magento → Shopify. We pre-fill the field mapping and keep consent safe.
          </EmptyState>
        )}
      </Card>
    </>
  );
}
